import { useQuery } from "@apollo/client";
import { GET_REVIEW_BY_STORE_ID } from "../../../api/store-review-queries";
import { GET_PACK } from "../../../api/store-queries";
import type {
  GetReviewByStoreIdQuery,
  GetReviewByStoreIdQueryVariables,
} from "../../../__generated__/graphql";
import type { PackQuery, PackQueryVariables } from "../../../__generated__/graphql";

export function usePackPageData(storeId: string | undefined) {
  const storeIdNum = storeId ? Number(storeId) : undefined;

  const { data, loading } = useQuery<PackQuery, PackQueryVariables>(GET_PACK, {
    variables: {
      storeId: storeIdNum ?? 0,
    },
    fetchPolicy: "network-only",
    skip: !storeIdNum,
  });

  const { data: reviewData } = useQuery<
    GetReviewByStoreIdQuery,
    GetReviewByStoreIdQueryVariables
  >(GET_REVIEW_BY_STORE_ID, {
    variables: { storeId: storeIdNum ?? 0, limit: 10, offset: 0 },
    skip: !storeIdNum,
  });

  const pack = data?.pack;
  const store = pack?.store;

  const packReviews =
    reviewData?.getReviewByStoreId?.filter(
      (review: GetReviewByStoreIdQuery["getReviewByStoreId"][number]) =>
        review.orderType === "PACK"
    ) ?? [];

  return {
    pack,
    store,
    loading,
    packReviews,
  };
}
